const contentful = require("contentful");

const client = contentful.createClient({
  space: "soj7k57zqdgu",
  accessToken: "Nx6cajuTYl96db7I4dFIJ6CVFbQG4Eq5EsWeyWPL0So",
});

export default client;